import { render, staticRenderFns } from "./ApplicantInformation.vue?vue&type=template&id=0b385e17"
import script from "./ApplicantInformation.vue?vue&type=script&lang=js"
export * from "./ApplicantInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports